import { IconCometeClockings, IconCometeLink } from '.';

const IconApp = (props) => {
  const { isClockingApp } = window.env;

  if (isClockingApp) {
    return <IconCometeClockings {...props} />;
  }

  return <IconCometeLink {...props} />;
};

export default IconApp;
